// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ov_5","col":"styles_col__2ryc-"};